import { render, staticRenderFns } from "./TableActiveSwitch.vue?vue&type=template&id=57635fd9&scoped=true"
import script from "./TableActiveSwitch.vue?vue&type=script&lang=ts"
export * from "./TableActiveSwitch.vue?vue&type=script&lang=ts"
import style0 from "./TableActiveSwitch.vue?vue&type=style&index=0&id=57635fd9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57635fd9",
  null
  
)

export default component.exports